import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from "@/contexts/i18n";
import { Box } from "@gemini/core";
import { useSuggestPriceCalculator } from "./hooks/useSuggestPriceCalculator";
import { formatPriceOutput } from "@/components/utilsComponents/suggestPrice/priceCalculationUtils";
import { ExclamationFilledCircleIcon } from "@gemini/icons";
export const PriceDifferenceBox = ({ percentageDifference, }) => {
    const { t } = useI18n();
    const { IS_EXCEEDING_THRESHOLD } = useSuggestPriceCalculator();
    return (_jsxs(Box, { marginTop: "spacing.24", borderWidth: "borderWidth.none", backgroundColor: IS_EXCEEDING_THRESHOLD
            ? "color.surface.status.warning.default"
            : "color.surface.light.default", borderRadius: "radius.16", width: "100%", padding: {
            "breakpoint.base": "spacing.16",
            "breakpoint.xxl": "spacing.16",
            "breakpoint.xxxl": "spacing.16",
        }, children: [_jsxs(Box, { width: "100%", display: "flex", flexDirection: "row", gap: "spacing.8", color: "color.surface.status.warningStrong.default", children: [IS_EXCEEDING_THRESHOLD && _jsx(ExclamationFilledCircleIcon, {}), _jsx(Box, { width: "50%", typography: {
                            "breakpoint.base": "typography.body.16.bold",
                        }, children: t("contact.form.suggest_price.price_difference") }), percentageDifference !== null && !isNaN(percentageDifference) && (_jsx(Box, { width: "50%", textAlign: "end", typography: {
                            "breakpoint.base": "typography.body.16.bold",
                        }, children: formatPriceOutput(percentageDifference) }))] }), _jsx(Box, { marginTop: "spacing.16", children: t("contact.form.suggest_price.warning_message") })] }));
};
